export const CODE = 'code';
export const NEW = 'new';
export const AVAILABILITY = 'availability';
